import React from "react";

import { Box, Grid, Tab, Tabs } from "@material-ui/core";

import {
  FormPageActions,
  LessonPreferences,
  LessonTypes,
  MyTestCentres,
  MyWorkingHours,
} from "@hubcapp/components";
import { TestCentre } from "@ds-developer/test-centres/dist/types";
import Content from "@ds-developer/content";
import PageHeader from "@ds-developer/page-header";

import { PreferencesProps } from "./types";

const Preferences: React.FC<PreferencesProps> = ({
  loading = false,
  updateLoading = false,
  tabs = [],
  franchiseType,
  selectedTab = "",
  onSubmit = () => {},
  onDiscard = () => {},
  onSelectTab = () => {},
  isFormValid = true,
  currentTravelTime = 0,
  testCentres,
}) => {
  const handleFormKeyDown = (event: React.KeyboardEvent<HTMLFormElement>) => {
    if (event.key === "Enter") event.preventDefault();
  };
  return (
    <Content>
      <form onSubmit={onSubmit} onKeyDown={handleFormKeyDown}>
        <PageHeader
          title="My preferences"
          breadcrumbs={[
            {
              title: "Home",
              link: "/",
            },
            {
              title: "Preferences",
            },
          ]}
        />

        <>
          {(loading || tabs.length > 1) && (
            <Tabs
              value={selectedTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={(e, value) => {
                onSelectTab(value);
              }}
              aria-label="Account tabs"
            >
              {tabs.map(tab => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  data-test={tab["data-test"]}
                  aria-label={tab["aria-label"]}
                />
              ))}
            </Tabs>
          )}

          <Box marginTop={3}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <LessonTypes loading={loading} />
              </Grid>
              <Grid item xs={12} md={6}>
                <LessonPreferences
                  franchiseType={franchiseType}
                  loading={loading}
                  disabled={updateLoading}
                  currentTravelTime={currentTravelTime}
                />
              </Grid>
            </Grid>
          </Box>

          <Box marginTop={3}>
            <MyWorkingHours loading={loading} disabled={updateLoading} />
          </Box>

          <Box marginTop={3}>
            <MyTestCentres data={testCentres as TestCentre[]} />
          </Box>

          <Box marginY={5}>
            <FormPageActions
              loading={updateLoading}
              submitDisabled={!isFormValid || updateLoading}
              onDiscardClick={onDiscard}
            />
          </Box>
        </>
      </form>
    </Content>
  );
};

export default Preferences;
